import React from 'react';
import { Link, useParams, useLocation } from 'react-router-dom';

export function BlogSidebar() {
  const { site_id } = useParams(); // Get site_id from route params
  const isActive = (path: string) => location.pathname.includes(path);
  const location = useLocation();
  return (
    <nav className="w-200 bg-gray-100 h-full p-10">
      <ul>
        <li className="mb-4">
          <Link
            to={`/${site_id}/posts`}
            className={`whitespace-nowrap flex items-center justify-start gap-10 block w-full rounded-button py-12 px-16 hover:bg-hover outline-none focus-visible:ring-2 ${isActive('/posts') ? 'text-primary bg-primary/6' : ''}`}
          >
            Posts 
          </Link>
        </li>
        <li className="mb-4">
          <Link
            to={`/${site_id}/categories`}
            className={`whitespace-nowrap flex items-center justify-start gap-10 block w-full rounded-button py-12 px-16 hover:bg-hover outline-none focus-visible:ring-2 ${isActive('/categories') ? 'text-primary bg-primary/6' : ''}`}
          >
            Categories
          </Link>
        </li>
        
      </ul>
    </nav>
  );
}
